import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import resources from "./locales";

export async function initI18n(language?: string) {
  const lng = language || "en";
  const fallbackLng = "en";

  await i18n.use(initReactI18next).init({
    resources,
    lng,
    fallbackLng,
    interpolation: {
      escapeValue: false,
    },
  });
}

export default i18n;
